/**
 * useDemoMode — Demo Data Toggle Hook (V108)
 *
 * In-memory state. NOT persisted. Toggle ON shows read-only demo data.
 * Toggling OFF returns to real user data instantly.
 *
 * Usage:
 *   const { demoMode, toggleDemo } = useDemoMode();
 *
 * Demo mode state is workspace-local — each workspace has its own toggle.
 * No cross-contamination between workspaces.
 */
import { useState, useCallback } from "react";

const demoModeState = {};  // module-level (not persisted)

export function useDemoMode(workspace) {
  const [demo, setDemo] = useState(demoModeState[workspace] || false);

  const toggleDemo = useCallback(() => {
    const next = !demoModeState[workspace];
    demoModeState[workspace] = next;
    setDemo(next);
  }, [workspace]);

  const exitDemo = useCallback(() => {
    demoModeState[workspace] = false;
    setDemo(false);
  }, [workspace]);

  return {
    demoMode: demo,
    toggleDemo,
    exitDemo,
    isDemoActive: demo,
  };
}
